import { ReactNode } from "react";

export const FaceIDProvider = ({ children }: { children: ReactNode}) => {
  return children;
}